import React, { useContext, useEffect } from 'react';
import { useFloatingScrollBarContext } from '../FloatingScrollBar/FloatingScrollBarContext';
import { TableContext } from '../TableContext';

export function TableFloatingScrollBarInitializer(props: {
  children: React.ReactElement;
}) {
  const { floatingScrollBarStateRef } = useFloatingScrollBarContext();
  const scrollElement = useContext(TableContext)?.scrollElement;

  useEffect(
    () => floatingScrollBarStateRef.current?.init(),
    [floatingScrollBarStateRef, scrollElement],
  );

  return props.children;
}
